import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useMember } from '../lib/members';

export default function Home() {
  const { user } = useAuth();
  const { member } = useMember(user?.uid ?? null);
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-navy">
        Välkommen{member ? `, ${member.firstName}` : ''}
      </h1>
      <div className="grid sm:grid-cols-2 gap-4">
        <Link
          to="/profil"
          className="block bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow"
        >
          <h2 className="font-semibold mb-1">Min profil</h2>
          <p className="text-sm text-gray-600">
            Uppdatera dina kontaktuppgifter.
          </p>
        </Link>
        <Link
          to="/mina-batar"
          className="block bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow"
        >
          <h2 className="font-semibold mb-1">Mina båtar</h2>
          <p className="text-sm text-gray-600">
            Båt- och bottenfärgsuppgifter per båtplats.
          </p>
        </Link>
      </div>
    </div>
  );
}
